export const defaultIconButtonStyles = () => `
  display: inline-block;
  width: 16px;
  height: 18px;
  border: none;
  outline: none;
  cursor: pointer;
  background: none;
`;
